import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import OrbatChart from "components/event/OrbatChart";
import styled from "styled-components";
import EventHeader from "components/event/EventHeader";
import LoadingSpinner from "components/LoadingSpinner";
import { useParams } from "react-router-dom";
import { modifyDocumentTitle } from "components/utils";
import images from "components/images";
import Snackbar from "@material-ui/core/Snackbar";
import { Alert } from "components/modify/Save";
import {
  getEventInfoAction,
  redirectAction,
  closeModalAction,
} from "store/actions";

export const Event = ({
  getSingleEvent,
  sides,
  eventDate,
  eventTitle,
  eventDesc,
  eventOwner,
  eventReserves,
  eventRepo,
  loading,
  error,
  newEventModalOpen,
  closeNewEventModal,
  newEventModalMessage,
  currentEvent,
  userIsOwner,
  redirect,
  total_slots,
  filled_slots,
  isMobile,
  liveUpdates,
}: any) => {
  const [currentEventID, setCurrentEventID] = useState(0);
  const [notificationModal, setNotificationModal] = useState({
    open: false,
    message: "",
  });
  let { id } = useParams<{ id }>();

  useEffect(() => {
    if (currentEventID !== id) {
      getSingleEvent(id);
      setCurrentEventID(id);
    }
  }, [currentEventID, id, getSingleEvent]);

  const handleClick = ({ message }) => {
    setNotificationModal({ open: true, message });
  };

  const handleClose = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    closeNewEventModal();
    setNotificationModal({ open: false, message: "" });
  };

  //We should do this a better way as it'll require setting manually on every page
  if (eventTitle) {
    modifyDocumentTitle(eventTitle);
  }

  if (id === "69") {
    return (
      <div style={{ display: "flex", padding: "60px", alignSelf: "center" }}>
        <img src={images["mlady"]} alt={"error"} />
      </div>
    );
  }

  if (error) {
    return (
      <ErrorBox>
        <img src={images["ErrorSymbol"]} alt={"error"} />
        There was a problem fetching this event.
      </ErrorBox>
    );
  }

  if (loading || !sides) {
    return <LoadingSpinner />;
  }

  return (
    <Wrapper>
      <EventHeader
        eventDate={eventDate}
        eventTitle={eventTitle}
        eventDesc={eventDesc}
        eventOwner={eventOwner}
        currentEvent={currentEvent}
        userIsOwner={userIsOwner}
        redirect={redirect}
        handleClick={handleClick}
        id={id}
        eventRepo={eventRepo}
        total_slots={total_slots}
        filled_slots={filled_slots}
        eventReserves={eventReserves}
        isMobile={isMobile}
        liveUpdates={liveUpdates}
      />
      <StyledOrbatChart sides={sides} />
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={notificationModal.open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="success">
          {notificationModal.message}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={newEventModalOpen}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="success">
          {newEventModalMessage}
        </Alert>
      </Snackbar>
    </Wrapper>
  );
};

const StyledOrbatChart = styled(OrbatChart)`
  max-width: inherit;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  background-color: #2f3136;
`;

const ErrorBox = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  place-content: center;
  flex-direction: column;
`;

const mapStateToProps = (state) => ({
  currentEvent: get(state, "rootReducer.orbat.selectedEvent"),
  error: get(state, "rootReducer.orbat.selectedEvent.error"),
  loading: get(state, "rootReducer.orbat.selectedEvent.loading"),
  sides: get(state, "rootReducer.orbat.selectedEvent.sides"),
  eventDate: get(state, "rootReducer.orbat.selectedEvent.event.event_date"),
  eventTitle: get(state, "rootReducer.orbat.selectedEvent.event.event_title"),
  eventDesc: get(state, "rootReducer.orbat.selectedEvent.event.event_desc"),
  eventOwner: get(state, "rootReducer.orbat.selectedEvent.event.event_owner"),
  eventReserves: get(
    state,
    "rootReducer.orbat.selectedEvent.event.event_reserves"
  ),
  eventRepo: get(state, "rootReducer.orbat.selectedEvent.event.event_repo"),
  newEventModalOpen: get(state, "rootReducer.core.modalOpen"),
  newEventModalMessage: get(state, "rootReducer.core.modalMessage"),
  userIsOwner: get(state, "rootReducer.orbat.isEditor"),
  total_slots: get(state, "rootReducer.orbat.selectedEvent.total_slots"),
  filled_slots: get(state, "rootReducer.orbat.selectedEvent.filled_slots"),
  isMobile: get(state, "rootReducer.core.isMobile", false),
  liveUpdates: get(state, "rootReducer.orbat.selectedEvent.liveUpdates", false),
});

const mapDispatchToProps = {
  redirect: redirectAction,
  getSingleEvent: getEventInfoAction,
  closeNewEventModal: closeModalAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Event);
